import React from 'react'

const getRole = (role) => {
    return ['wk', 'cap', 'wkcap'].includes(role) ? ` (${role})` : '';
}
const BatsmanRow = ({ item }) => {
    const { name, runs, ballsfaced, balls_faced, fours, sixes, how_out, role, position, strikerate,strike_rate } = item;
    return (

        <div className={`scorecard-row ${position}`}>
            <div className='rh1' style={{ paddingLeft: 3, borderLeft: ( position == 'non-striker' || position == 'striker') ? '3px solid green' : '3px solid #f2f2f2' }}>
                <div style={{ fontWeight: ( position == 'non-striker' || position == 'striker') ? '900' : 'normal' }}>
                    {name} {getRole(role)}
                </div>
                <div className="howout">
                    {how_out} {position ? <span style={{
                        fontWeight: 500
                    }}>  |  {position}</span> : ''}
                </div>
            </div>
            <div className='rh2'>
                {runs}
            </div>
            <div className='rh2'>
                {ballsfaced||balls_faced }
            </div>
            <div className='rh3' >
                {fours}
            </div>
            <div className='rh3'>
                {sixes}
            </div>
            <div className='rh4'>
                {strikerate||strike_rate}
            </div>
        </div>

    )
}


const BowlerRow = ({ item }) => {

    const { name, maidens, overs, runs_conceded, wickets, econ, position } = item;
    return (
        <div className={`scorecard-row ${position}`}>
            <div className='rh1'>
                <div style={{ fontWeight: ( position == 'active bowler') ? '900' : 'normal', paddingLeft: 3, borderLeft: ( position == 'active bowler') ? '3px solid green' : '3px solid #f2f2f2' }}>
                    {name}
                </div>
            </div>
            <div className='rh2'>
                {overs}
            </div>
            <div className='rh2'>
                {maidens}
            </div>
            <div className='rh3' >
                {runs_conceded}
            </div>
            <div className='rh3'>
                {wickets}
            </div>
            <div className='rh4'>
                {econ}
            </div>
        </div>
    )
}
const FowRow = ({ item }) => {

    const { name, score_at_dismissal, number, overs_at_dismissal } = item;
    return (
        <div className="scorecard-row">
            <div className="rh6" style={{
                fontWeight: "700"
            }}>
                {name}
            </div>
            <div className="rh7">
                {`${score_at_dismissal}/${number}`}
            </div>
            <div className="rh7">
                {overs_at_dismissal}
            </div>
        </div>
    )
}


export {
    BatsmanRow,
    BowlerRow,
    FowRow
}